module.exports = __webpack_public_path__ + "static/media/twitter.e53da3ad.svg";